import { Wsm2026Prediction } from "../../Wsm2026Prediction";
import { Wsm2023ModifyCommandFactory } from "./Wsm2023ModifyCommandFactory";

export class Wsm2026ModifyCommandFactory extends Wsm2023ModifyCommandFactory {
	constructor(competition: Wsm2026Prediction) {
		super(competition);
	}
}